module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.61d09e10.eot";